import * as RT from "@radix-ui/react-tooltip";
import type { JSX, ReactNode } from "react";

import { cn } from "@/shared/lib/cn";

export function TooltipProvider(props: RT.TooltipProviderProps): JSX.Element {
  return <RT.Provider {...props} />;
}

interface TooltipProps {
  content: ReactNode;
  children: ReactNode;
  delayDuration?: number;
  side?: "top" | "right" | "bottom" | "left";
  className?: string;
}

export function Tooltip({
  content,
  children,
  delayDuration = 200,
  side = "top",
  className,
}: TooltipProps): JSX.Element {
  return (
    <RT.Root delayDuration={delayDuration}>
      <RT.Trigger asChild>{children}</RT.Trigger>
      <RT.Portal>
        <RT.Content
          side={side}
          sideOffset={6}
          role="tooltip"
          className={cn(
            "z-50 max-w-xs rounded-md bg-[var(--ink-900)] px-2 py-1.5 text-xs text-[var(--text-inverse)] shadow-[var(--sh-2)]",
            className,
          )}
        >
          {content}
          <RT.Arrow className="fill-[var(--ink-900)]" />
        </RT.Content>
      </RT.Portal>
    </RT.Root>
  );
}
